import {useState, useEffect} from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Box from "@mui/material/Box";

import Loading from '../../common/Loading';

export default function FilterCustomerProjectList(props) {
    //console.debug("RTS Break LoadListFilterProjectList");

    const [isLoading, setIsLoading] = useState(true);
    
    const [projects, setProjects] = useState();
    const [repoProjects, setRepoProjects] = useState();


    useEffect(() => {
        if(props.projects===null){
            setProjects([]);
        }
        else{
            setProjects(props.projects);
        }

        if(props.data == null){
            setRepoProjects([]);
        }
        else{
            setRepoProjects(props.data);
        }

        setIsLoading(false);
    }, [props]);     

    
    function valChange(e, val){
        props.setProjectsFx(val);
        setProjects(val);
    }


    if(isLoading){
        return(
            <Loading />
        );
    }


    return(
        <>
            <Autocomplete
                options={repoProjects}
                renderInput={(params) => <TextField {...params} label="Projects" size="small" />}
                value={projects}
                onChange={valChange}
                getOptionLabel={(project) => project?.name}
                renderOption={(props, repoProjects) => (
                    <Box component="li" {...props} key={repoProjects?.idGuid}>
                        {repoProjects?.name}
                    </Box>
                )}
                multiple
            />
        </>
    );
}


